import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import ComposedTextField from '../ComposedField/ComposedTextField';
import { maxLength, minLength, hasUpperAndLowerCharacters, hasNumericCharacters, hasSpecialCharacters, hasNoSpacesAtBeginningOrEnd, hasNoConsecutiveSpaces } from '@parchment/validation-utils';
function defaultValidators(context) {
  switch (context) {
    case 'create':
      return [{
        message: 'Must be at least 10 characters long',
        callback: minLength.bind(null, 10)
      }, {
        message: 'Must be less than 60 characters long',
        callback: maxLength.bind(null, 60)
      }, {
        message: 'Must contain at least 1 upper and 1 lower characters',
        callback: hasUpperAndLowerCharacters
      }, {
        message: 'Must contain at least 1 number',
        callback: hasNumericCharacters
      }, {
        message: 'Must contain at least 1 special character',
        callback: hasSpecialCharacters
      }, {
        message: 'Must not contain spaces at the beginning or at the end of password',
        callback: hasNoSpacesAtBeginningOrEnd
      }, {
        message: 'Must not contain consecutive spaces in the password',
        callback: hasNoConsecutiveSpaces
      }];
    default:
      return [];
  }
}
export default function Password(_ref) {
  let {
    name = 'password',
    label = 'Password',
    context = 'create',
    validators = defaultValidators(context),
    ...props
  } = _ref;
  const {
    value = '',
    ...remainingProps
  } = props;
  const autoComplete = context === 'authenticate' ? 'current-password' : 'new-password';
  return /*#__PURE__*/React.createElement(ComposedTextField, _extends({}, remainingProps, {
    name: name,
    type: "password",
    label: label,
    autoComplete: autoComplete,
    validators: validators,
    value: value,
    required: true
  }));
}